import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { hitApi, commonToast } from "../../components/commonAction";
import AffiliatePageLayout from "./AffiliatePageLayout";

export default function Signup({ pageTitle }) {
    const navigate = useNavigate();
    const [paypalEmail, setPaypalEmail] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [done, setDone] = useState(false);

    const submit = (e) => {
        e.preventDefault();
        if (!paypalEmail.trim()) { commonToast("error", "PayPal email is required."); return; }
        setSubmitting(true);
        hitApi(
            { url: "affiliate/signup", method: "POST", data: { paypalEmail }, alert: false },
            (resp) => {
                setSubmitting(false);
                if (resp?.status) {
                    commonToast("success", resp.message);
                    setDone(true);
                }
            }
        );
    };

    return (
        <AffiliatePageLayout pageTitle={pageTitle} heading="Become an affiliate" hideTabs>
            {done ? (
                <div className="pxl-panel" style={{ maxWidth: 640 }}>
                    <div className="pxl-panel-header">Almost there</div>
                    <div className="pxl-panel-body">
                        <p style={{ color: "#4f536f" }}>
                            Your application is in. An admin will review and approve it shortly. Once
                            approved, you'll receive an email with your referral code and your
                            dashboard will activate.
                        </p>
                        <p style={{ fontSize: 13, color: "#8a8fa6", marginBottom: 0 }}>
                            <strong>Note:</strong> log out and log back in once approved — your existing
                            session token still says you're a regular user. The new role takes effect
                            at next login.
                        </p>
                    </div>
                </div>
            ) : (
                <div className="pxl-panel" style={{ maxWidth: 640 }}>
                    <div className="pxl-panel-header">Apply</div>
                    <div className="pxl-panel-body">
                        <p style={{ color: "#4f536f" }}>
                            Promote PixaLab and earn commission on every customer you refer. Submit
                            your PayPal email below — that's where payouts will be sent once
                            approved.
                        </p>
                        <form onSubmit={submit} className="pxl-affiliate-form">
                            <div className="pxl_input_feilds">
                                <label>
                                    PayPal email <span className="pxl-star-red">*</span>
                                </label>
                                <input
                                    type="email"
                                    value={paypalEmail}
                                    onChange={e => setPaypalEmail(e.target.value)}
                                    placeholder="payouts@example.com"
                                    required
                                />
                            </div>
                            <div style={{ display: "flex", gap: 12, marginTop: 16 }}>
                                <button type="submit" className="pxlCommon-btn" disabled={submitting}>
                                    {submitting ? "Submitting…" : "Apply to be an affiliate"}
                                </button>
                                <button type="button" className="btn btn-link" onClick={() => navigate(-1)}>
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </AffiliatePageLayout>
    );
}
